import * as tf from '@tensorflow/tfjs';

let model;
let metadata;

const MODEL_URL = 'https://storage.googleapis.com/tfjs-models/tfjs/sentiment_cnn_v1/model.json';
const METADATA_URL = 'https://storage.googleapis.com/tfjs-models/tfjs/sentiment_cnn_v1/metadata.json';

export const loadModel = async () => {
  if (!model) {
    model = await tf.loadLayersModel(MODEL_URL);
  }
  return model;
};

export const loadMetadata = async () => {
  if (!metadata) {
    const response = await fetch(METADATA_URL);
    metadata = await response.json();
  }
  return metadata;
};

export const analyzeSentiment = async (text) => {
  await loadModel();
  await loadMetadata();

  const trimmed = text.trim().toLowerCase().replace(/[.,!]/g, '').split(' ');


  const sequence = trimmed.map(word => {
    const index = metadata.word_index[word];
    return typeof index === 'undefined' ? 2 : index + metadata.index_from;
  });

  const padded = padSequences([sequence], metadata.max_len);
  const input = tf.tensor2d(padded, [1, metadata.max_len]);
  const prediction = model.predict(input);
  const score = prediction.dataSync()[0];
  prediction.dispose();

  return score; // 0 (negative) to 1 (positive)
};

const padSequences = (sequences, maxLen) => {
  return sequences.map(seq => {
    if (seq.length > maxLen) {
      seq.splice(0, seq.length - maxLen);
    }
    if (seq.length < maxLen) {
      const pad = new Array(maxLen - seq.length).fill(0);
      seq = pad.concat(seq);
    }
    return seq;
  });
};
